<template>
    <vx-table-row>
        <div
            class="membership-status-handle"
            :class="props.disabled ? 'pointer-events-none opacity-50' : 'cursor-move'"
        >
            <font-awesome-icon widthAuto :icon="faGripDotsVertical"></font-awesome-icon>
        </div>

        <vx-table-row-title class="truncate">
            {{ props.definition.name }}
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label>Classification Steering:</template>
            <div class="text-sm text-slate-500 line-clamp-2">
                {{ props.definition.classification_steering }}
            </div>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label>Message Steering:</template>
            <div class="text-sm text-slate-500 line-clamp-2">
                {{ props.definition.message_steering }}
            </div>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-button
                data-test="delete-btn"
                outline
                color="muted"
                :disabled="props.disabled"
                @click="emit('delete', props.definition)"
            >
                <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
            </vx-button>
            <vx-button
                data-test="edit-btn"
                outline
                color="muted"
                :disabled="props.disabled"
                @click="emit('edit', props.definition)"
            >
                Edit <font-awesome-icon widthAuto :icon="faFilePen"></font-awesome-icon>
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { faFilePen, faGripDotsVertical, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxTableRow, VxTableRowButtons, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import type { MembershipStatusDefinitionType } from '~/services/intelligentInboxSettings/intelligentInboxSettingsClient.types';

const props = defineProps<{
    definition: MembershipStatusDefinitionType;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    edit: [definition: MembershipStatusDefinitionType];
    delete: [definition: MembershipStatusDefinitionType];
}>();
</script>
